import React, { Component } from "react";

import HeroSection from "../components/HeroSection/HeroSectionSignUp2";

class SignUp extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="main">
          <HeroSection />
        </div>  
      </React.Fragment>
    );
  }
}

export default SignUp;
